document.addEventListener("DOMContentLoaded", function () {
  const sliderElements = document.querySelectorAll(".carousel");

  function initializeCustomFlickity(elem) {
    const flkty = new Flickity(elem, {
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
    });

    const scrollbarWrapper = elem.parentNode.querySelector(
      ".carousel-scrollbar-wrapper"
    );
    const scrollbar = scrollbarWrapper.querySelector(".carousel-scrollbar");

    function updateScrollbar() {
      const cells = elem.querySelectorAll(".carousel-cell");
      const contentWidth = Array.from(cells).reduce((total, cell) => {
        const cellWidth = cell.offsetWidth;
        const totalWidth = cellWidth + 6.5;
        return total + totalWidth;
      }, 0);

      const visibleWidth = elem.offsetWidth;

      if (contentWidth <= visibleWidth) {
        scrollbarWrapper.style.display = "none";
      } else {
        scrollbarWrapper.style.display = "block";
        const scrollbarWidth =
          (visibleWidth / contentWidth) * scrollbarWrapper.offsetWidth;
        scrollbar.style.width = `${scrollbarWidth}px`;
      }
    }

    flkty.on("resize", updateScrollbar);
    flkty.on("ready", updateScrollbar);

    flkty.on("scroll", function (progress) {
      const maxScrollLeft = scrollbarWrapper.offsetWidth - scrollbar.offsetWidth;
      scrollbar.style.transform = `translateX(${progress * maxScrollLeft}px)`;
    });

    elem.addEventListener("mousedown", function (e) {
      const startX = e.pageX;

      document.body.classList.add("no-select");

      function onMouseUp(e) {
        const deltaX = e.pageX - startX;
        if (deltaX > 0) {
          flkty.next(true);
        } else if (deltaX < 0) {
          flkty.previous(true);
        }

        document.removeEventListener("mouseup", onMouseUp);
        document.body.classList.remove("no-select");
      }

      document.addEventListener("mouseup", onMouseUp);
    });

    scrollbar.addEventListener("mousedown", function (e) {
      scrollbarWrapper.classList.add('scroll-bar-visible')
      const startX = e.pageX;
      const initialScrollLeft = scrollbar.offsetLeft;

      document.body.classList.add("no-select");

      function onMouseMove(e) {
        const deltaX = e.pageX - startX;
        const maxScrollLeft =
          scrollbarWrapper.offsetWidth - scrollbar.offsetWidth;
        const scrollbarPosition = Math.min(
          Math.max(initialScrollLeft + deltaX, 0),
          maxScrollLeft
        );

        scrollbar.style.transform = `translateX(${scrollbarPosition}px)`;

        const progress = scrollbarPosition / maxScrollLeft;
        flkty.x = -progress * (flkty.slideableWidth - flkty.size.width);
        flkty.positionSlider();
      }

      function onMouseUp() {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
        document.body.classList.remove("no-select");
        scrollbarWrapper.classList.remove('scroll-bar-visible')
      }

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    });

    updateScrollbar();
  }

  function initializeStandardFlickity(elem) {
    return new Flickity(elem, {
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
    });
  }

  function handleResize() {
    sliderElements.forEach(function (elem) {
      const flickityInstance = Flickity.data(elem);

      if (window.matchMedia("(max-width: 480px)").matches) {
        initializeStandardFlickity(elem);
      } else {
        initializeCustomFlickity(elem);
      }
    });
  }

  window.addEventListener("resize", function() {
    handleResize();
  });

  handleResize();
});